import Slider from 'react-slick'
import './other-collections.sass'

export default function OtherCollections({ collections }) {
  const settings = {
    slidesToShow: 4,
    slidesToScroll: 4,
    infinite: false,
    dots: true,
    responsive: [
      { breakpoint: 1025, settings: { slidesToShow: 4, slidesToScroll: 4 } },
      { breakpoint: 769, settings: { slidesToShow: 2.5, slidesToScroll: 1, arrows: false } },
      { breakpoint: 481, settings: { slidesToShow: 1.2, slidesToScroll: 1, arrows: false } },
    ],
  }

  return (
    <Slider className='slick-pt-custom same-height' {...settings}>
      {
        collections.map((collection) => {
          return (
            <a className='other-collections' key={collection.title} href={collection.url}>
              <div className='other-collections__image' style={{
                backgroundImage: `url(${collection.background})`,
              }} />
              <p className='other-collections__title' >{ collection.title }</p>
            </a>
          )
        })
      }
    </Slider>
  )
}
